import { withUrl, Request, list, get, ItemRequest } from '@factorin/rest';

import { RenderData } from 'Modules/business/editor-render/render';


interface NewsRequest {
    Tags?: string[];
}

interface NewsCommon {
    Date?: string;
    Id: string;
    Tags?: string[];
}

export interface NewsPaginationElement extends NewsCommon {
    Description?: string;
    Img?: string;
    Title?: string;
}
export interface News extends NewsCommon{
    Content: RenderData;
}

interface NeighboursRequest extends ItemRequest {
    tags?: string[];
}

export type Neighbours = Record<'Previous' | 'Next', NewsPaginationElement>;

export const NEWS_DOMAIN_PATH = 'news';
const newsPart = withUrl('news');
export const news = {
    ...list<News, Request.Query<NewsRequest>, NewsPaginationElement>(newsPart()),
    neighbours: get<Request.Query<NeighboursRequest>, Neighbours>(
        ({ query: { id, ...query } }) => newsPart({
            path: `neighbours/${id}`,
            query,
        }),
    ),
};
